<template>
  <VueJsModalPrimary
    v-bind="attrs.modal"
    :name="name"
  >
    <div :style="style.container">
      <LinkPrimary
        :href="helpCenter"
        :openInCurrentTab="false"
        :style="style.link"
      >
        Help Center
      </LinkPrimary>
      <LinkPrimary
        :href="contactSupport"
        :style="style.link"
      >
        Contact Support
      </LinkPrimary>
      <LinkPrimary
        :href="linkTermsOfService"
        :openInCurrentTab="false"
        :style="style.link"
      >
        Terms of Service
      </LinkPrimary>
      <LinkPrimary
        :href="linkPrivacyPolicy"
        :openInCurrentTab="false"
        :style="style.link"
      >
        Privacy Policy
      </LinkPrimary>
    </div>
  </VueJsModalPrimary>
</template>

<script>
  import LinkPrimary from '@modules/link/link-primary'
  import VueJsModalPrimary from '@modules/v2/modal/vue-js-modal-primary'
  import { EXTERNAL_LINKS } from '@js/constants'
  import { Layout } from '@js/styles'
  import { MODAL_WINDOW_NAMES } from '@js/constants'

  export default {
    name: 'ModalHelpPrimary',
    components: {
      LinkPrimary,
      VueJsModalPrimary,
    },
    data: function () {
      return {
        contactSupport: EXTERNAL_LINKS.CONTACT_SUPPORT,
        helpCenter: EXTERNAL_LINKS.HELP_CENTER,
        linkPrivacyPolicy: EXTERNAL_LINKS.PRIVACY_POLICY,
        linkTermsOfService: EXTERNAL_LINKS.TERMS_OF_SERVICE,
        name: MODAL_WINDOW_NAMES.HELP_PRIMARY,
        attrs: {
          modal: {
            maxWidth: 360,
            height: 'auto',
          },
        },
        style: {
          container: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            padding: `${Layout.space.md} 0`,
            width: '100%',
          },
          link: {
            padding: `${Layout.space.sm} 0`,
            diplay: 'block',
          },
        },
      };
    },
  };
</script>
